"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchematicReferenceSchema = void 0;
const zod_1 = require("zod");
const Module_1 = require("./DrawingModels/Module");
exports.SchematicReferenceSchema = zod_1.z.object({
    type: zod_1.z.literal('schref'),
    name: zod_1.z.string(),
    file: zod_1.z.string(),
    designId: zod_1.z.string().nullable(),
    drawModule: Module_1.ModuleSchema,
});
//# sourceMappingURL=SchematicReference.js.map